<template>
  <div class="La3" :style="{
    gridTemplateColumns: ratio
  }">
    <div class="La3_left" :style="styleLeft">
      <slot name="left"/>
    </div>
    <div class="La3_center" :style="styleCenter">
      <slot name="center"/>
    </div>
    <div class="La3_right" :style="styleRight">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ratio', 'styleLeft', 'styleCenter', 'styleRight']

}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  .La3 {
    background-color: #FFFFFF;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 89px);
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-rows: 100%;
    gap: 0;
    .La3_left {
      flex: 1 1 auto;
      overflow: hidden;
      overflow-y: auto;
      border-right: 1px solid #B9B9B9;
    }
    .La3_center {
      flex: 1 1 auto;
      overflow: hidden;
      overflow-y: auto;
      border-right: 1px solid #B9B9B9;
    }
    .La3_right {
      flex: 1 1 auto;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (orientation: portrait) {
  .La3 {
    display: flex;
    flex-direction: column;
  }
}
</style>
